import { ToolsPage } from ".";
import { MenuNode, MenuRoute } from "../../components/menu";
import { ShellRouteNames } from "../shell/route-names";
import { FraudRoutes } from "../kyc-kyb-aml/routes";
import { AllKYCsComponent } from "../kyc-kyb-aml/individual-kyc/all";
import { Transition, useRouter } from "@uirouter/react";
import { LeafRole } from "../../utils/and-or-tree";
// import { router } from "../../router";

const names = {
  tools: `${ShellRouteNames.shell}.tools`,
};

const states: MenuRoute[] = [
  {
    name: names.tools,
    component: ToolsPage,
    url: "/tools",
    data: {
      title: "marketing",
      roles: new LeafRole("ROLE_ADMIN"),
    },
  },
  // {
  //   name: FraudRoutes.names.allIndividualKyc,
  //   component: AllKYCsComponent,
  //   url: "/tools/kyc?query",
  //   data: {
  //     title: "all-reports",
  //     roles: [new LeafRole("ROLE_ADMIN")],
  //   },
  //   params: {
  //     query: {
  //       type: "string",
  //       isOptional: true,
  //       dynamic: true,
  //     },
  //   },
  //   resolve: [
  //     {
  //       token: "query",
  //       policy: { when: "EAGER" },
  //       deps: [Transition],
  //       resolveFn: (t: Transition) => t.params().query,
  //     },
  //     {
  //       provide: "status",
  //       useValue: "IN_REVIEW",
  //     },
  //   ],
  // },
];

const useSidebar: () => MenuNode.MenuNode = () => {
  const router = useRouter();

  return {
    icon: "tools",
    title: "Tools",
    children: [
      {
        icon: "tools",
        route: states[0],
      },
      {
        icon: "tools",
        target: router.stateService.target(FraudRoutes.names.allIndividualKyc, {
          status: "IN_REVIEW",
        }),
        title: "In Review KYCs",
      },
    ],
    roles: new LeafRole("ROLE_ADMIN"),
  };
};

export const ToolsRoutes = {
  names,
  states,
  useSidebar,
};
